const GOOGLE_AUTH_CLIENT_ID = '826931020910-it5f8lq91h4gncapfbj3nsvhn4m0sral.apps.googleusercontent.com';

export { GOOGLE_AUTH_CLIENT_ID };